import { render, staticRenderFns } from "./upload-video-process.vue?vue&type=template&id=b012adc6&scoped=true"
import script from "./upload-video-process.vue?vue&type=script&setup=true&lang=js"
export * from "./upload-video-process.vue?vue&type=script&setup=true&lang=js"
import style0 from "./upload-video-process.vue?vue&type=style&index=0&id=b012adc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b012adc6",
  null
  
)

export default component.exports